import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { AuthServiceUser } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthServiceUser, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = this.authService.getToken();
    if (token) {
      // Check if token is expired
      // const isExpired = this.isTokenExpired(token);
      const isExpired = false; // Need to update this code
      if (!isExpired) {
        return true;
      } else {
        // Token is expired; attempt to refresh it
        this.authService.refreshTokenRequest().subscribe({
          next: () => true,
          error: () => {
            this.router.navigate(["/login"]);
            return false;
          },
        });
      }
    } else {
      this.router.navigate(["/login"]);
      return false;
    }
    return false;
  }

  private isTokenExpired(token: string): boolean {
    const payload = JSON.parse(token.split(".")[1]);
    return Date.now() >= payload.exp * 1000;
  }
}
